/**
 * Centralized registry of Dynatrace short URLs used across Strato components.
 * @internal
 */

/** DQL language reference documentation. */
export const DQL_DOCUMENTATION_URL = 'https://dt-url.net/dql-help';

/**
 * Base URL prefix for per-command/function DQL documentation links.
 * Append the encoded token type and name to form a complete URL.
 */
export const DQL_DOCUMENTATION_URL_PREFIX = 'https://dt-url.net/dql_';

/** Segments feature documentation. */
export const SEGMENTS_DOCUMENTATION_URL =
  'https://dt-url.net/segments-documentation';

/** Timeframe selector documentation. */
export const TIMEFRAME_SELECTOR_DOCUMENTATION_URL =
  'https://dt-url.net/timeframe-selector';
